module.exports = __webpack_public_path__ + "img/DK25213483.d62f2601.png";